import { Auth } from "../../store/ducks/auth/types";
import { RULES } from "../../store/ducks/rule/types";
import { hasRule } from "../../store/ducks/auth/utils";

export const hasAccess = (auth: Auth | null, rule: RULES) =>
  auth && hasRule(auth, rule);
